import * as React from 'react'

import { UnreachableCaseError } from 'main/util/ts'
import EmailExistsError from './EmailExistsError'
import GenericError from './GenericError'

export enum ErrorType {
  EmailExists = 'email_exists',
  Generic = 'generic',
}

interface IProps {
  type: ErrorType
  onRequestLogin: () => void
}

export default function Error(props: IProps) {
  const { type, onRequestLogin } = props

  switch (type) {
    case ErrorType.EmailExists:
      return <EmailExistsError onRequestLogin={onRequestLogin} />

    case ErrorType.Generic:
      return <GenericError />

    default:
      throw new UnreachableCaseError(type)
  }
}
